<ez-main-layout [theme]="Themes.WHITELABEL">
  <ez-banner>
    <span ngProjectAs="title">Willkommen</span>
    <span ngProjectAs="subtitle">Verifizierung nicht möglich</span>
  </ez-banner>
  <p>
    Die automatisierte Überprüfung Ihrer Daten konnte nicht erfolgreich abgeschlossen werden. Bitte versuchen Sie es
    erneut.
  </p>
  <p>
    Falls das Problem weiter besteht, wenden Sie sich gerne an uns. Die Kontaktdaten finden Sie in unserem Anschreiben.
  </p>
</ez-main-layout>
